import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom"; // or whatever routing library you're using
import Header from "../../components/Layout/Header";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Layout/Main";
import Sidebar from "../../components/Layout/Sidebar";

import SweetAlertWrapper from "../../components/Layout/sweetAlert";

import CustomersContext from "../../context/otogas/customers/customersContext";

const customerTypeOptions = [
    { value: "OUTRIGHT", label: "Outright Installment" },
    { value: "RENTAL", label: "Rental Installment" },
    { value: "CONVERSION", label: "Conversion Recovery Installment" },
    { value: "WALK_IN", label: "Walk-In Customer" },
];

const AddCustomers = () => {
    const navigate = useNavigate();

    const customerContext = useContext(CustomersContext);
    const {
        addCustomer,
        updateCustomer,
        selected_customer,
        notification,
        clear_notification,
    } = customerContext;

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ text: "", type: "" });

    const handleConfirm = () => {
        setShowAlert(false);
        if (notification?.type === "success") {
            navigate("/customers");
        }
        clear_notification();
    };

    const page = "Add Customer";

    const [customer, setCustomer] = useState({
        customerName: "",
        customerPhone: "",
        customerEmail: "",
        krapin: "",
        identificationNumber: "",

        // 🔹 NEW FIELDS
        customerCategory: "OUTRIGHT", // default to KYC customer
        street: "",
        postalCode: "",
        city: "",
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setCustomer((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Optional: if editing, hydrate from selected_customer
    useEffect(() => {
        if (selected_customer) {
            setCustomer((prev) => ({
                ...prev,
                customerName: selected_customer.customerName || "",
                customerPhone: selected_customer.customerPhone || "",
                customerEmail: selected_customer.customerEmail || "",
                krapin: selected_customer.krapin || "",
                identificationNumber:
                    selected_customer.identificationNumber || "",
                customerCategory:
                    selected_customer.customerCategory || "OUTRIGHT",
                street: selected_customer.street || "",
                postalCode: selected_customer.postalCode || "",
                city: selected_customer.city || "",
            }));
        }
    }, [selected_customer]);

    useEffect(() => {
        if (notification) {
            setAlertMessage({
                text: notification.text,
                type: notification.type,
            });
            setShowAlert(true);
        }
    }, [notification]);

    const onSubmit = (e) => {
        e.preventDefault();
        if (selected_customer) {
            updateCustomer(customer);
        } else {
            addCustomer(customer);
        }
    };

    return (
        <div className="niceadmin">
            <Header />
            <Sidebar page={page} />
            <Main>
                <SweetAlertWrapper
                    show={showAlert}
                    title="Notification"
                    message={alertMessage.text}
                    onConfirm={handleConfirm}
                    confirmBtnText="OK"
                    type={alertMessage.type || "info"}
                />
                <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <div className="align-center">
                                            <h5 className="card-title">
                                                Add Customer
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <form onSubmit={onSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="customerName">
                                            Customer Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="customerName"
                                            name="customerName"
                                            value={customer.customerName}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="customerPhone">
                                            Customer Phone
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="customerPhone"
                                            name="customerPhone"
                                            value={customer.customerPhone}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="customerEmail">
                                            Customer Email
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="customerEmail"
                                            name="customerEmail"
                                            value={customer.customerEmail}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="krapin">KRA Pin</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="krapin"
                                            name="krapin"
                                            value={customer.krapin}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="identificationNumber">
                                            Identification Number
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="identificationNumber"
                                            name="identificationNumber"
                                            value={customer.identificationNumber}
                                            onChange={onChange}
                                        />
                                    </div>

                                    {/* 🔹 NEW: Customer Type (Outright / Rental / Conversion / Walk-In) */}
                                    <div className="form-group">
                                        <label>Customer Type</label>
                                        <Select
                                            options={customerTypeOptions}
                                            value={
                                                customerTypeOptions.find(
                                                    (opt) =>
                                                        opt.value ===
                                                        customer.customerCategory
                                                ) || null
                                            }
                                            onChange={(selectedOption) => {
                                                setCustomer((prev) => ({
                                                    ...prev,
                                                    customerCategory:
                                                        selectedOption?.value ||
                                                        "OUTRIGHT",
                                                }));
                                            }}
                                            placeholder="Select Customer Type"
                                        />
                                    </div>

                                    {/* 🔹 NEW: Address fields (Street, Postal Code, City) */}
                                    <div className="form-group">
                                        <label htmlFor="street">Street</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="street"
                                            name="street"
                                            value={customer.street}
                                            onChange={onChange}
                                            placeholder="e.g. Mombasa Road"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="postalCode">
                                            Postal Code
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="postalCode"
                                            name="postalCode"
                                            value={customer.postalCode}
                                            onChange={onChange}
                                            placeholder="e.g. 00500"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="city">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="city"
                                            name="city"
                                            value={customer.city}
                                            onChange={onChange}
                                            placeholder="e.g. Nairobi"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </Main>
        </div>
    );
};

export default AddCustomers;
